export default "https://cdn-static-unstable.gokick.com/assets/b4100b98dde63e1c7260221a4305ac191c7ac51c/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";